<div id="omp-account-types">

    <h1>{{ 'REGISTRATION_PAGE.accountTypeSection.ompAccountType' | translate }}</h1>

    <div class="d-md-flex mt-2">
        <div class="card mb-2 ">
            <div class="card-body">
                <div class="p-grid mt-5 mb-5 ">
                    <div class="p-col-12 mt-3" *ngFor="let accountType of accoutTypes; let i = index" >
                      <fieldset>
                        <legend class="wcag-visuallyhidden">{{ 'REGISTRATION_PAGE.accountTypeSection.ompAccountType' | translate }}</legend>
                            <div class="d-flex align-items-center" *ngIf="hideOption(accountType.id)">
                                    <p-radiobutton
                                        name="group1"
                                        [value]="accountType"
                                        [inputId]="'omp-account-type-' + accountType.id"
                                        [(ngModel)]="selectionAccountType"
                                        wcag-label
                                    ></p-radiobutton>
                                <label class="ml-2 mb-0" [for]="'omp-account-type-' + accountType.id">
                                     {{ 'REGISTRATION_PAGE.accountTypeSection.' + accountType.name | translate }}
                                </label>
                            </div>
                      </fieldset>
                    </div>
                </div>
                <div class="p-grid mb-5 ">
                    <p-fieldset
                      *ngIf="selectionAccountType"
                      legend="{{ 'REGISTRATION_PAGE.accountTypeSection.purposeOfAccount' | translate }}" fieldsetAriaFix>
                      <app-blurb [message]="'REGISTRATION_PAGE.accountTypeSection.accountOpeningReason'"></app-blurb>
                        <div class="p-grid">
                            <div class="p-col-12 m-3" *ngFor="let type of registrationType; let j = index" >
                              <fieldset>
                                <legend class="wcag-visuallyhidden">{{ 'REGISTRATION_PAGE.accountTypeSection.purposeOfAccount' | translate }}</legend>
                                    <div class="d-flex align-items-center">
                                        <p-radiobutton
                                            name="group2"
                                            [value]=" type "
                                            [inputId]="'omp-registration-type-' + type.id"
                                            [(ngModel)]="selectionAccountRegistraionType"
                                            wcag-label
                                      ></p-radiobutton>
                                    <label class="ml-2 mb-0" [for]="'omp-registration-type-' + type.id">
                                        {{ 'REGISTRATION_PAGE.accountTypeSection.'+type.name | translate }}
                                    </label>
                                </div>
                              </fieldset>
                            </div>
                        </div>
                    </p-fieldset>
                </div>
            </div>
            <div class="card-footer">
                <button *ngIf="!isSubaccount && showBackButton" class="btn btn-secondary mr-2" (click)="backStep()">{{ 'REGISTRATION_PAGE.stepperSection.back' | translate }}</button>
                <button  id="nfmp-stp2-btn"  class="btn btn-primary" (click)="nextStep()"  [disabled]="onlyIfNoselection()">{{ 'REGISTRATION_PAGE.accountTypeSection.select' | translate }}</button>
            </div>
        </div>
    </div>

</div>
